import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { FaExclamationCircle, FaCheckCircle, FaTasks, FaExclamationTriangle } from 'react-icons/fa'; // Example icons
import cx from 'classnames';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
  Progress,
  Badge,
  Table,
  Alert,
  Spinner
} from 'reactstrap';
import {
  PieChart as RePieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  Legend as ReLegend,
  BarChart as ReBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
} from 'recharts';
import {  useNavigate } from 'react-router-dom';

import Widget from '../../components/Widget/Widget';
import LineChart from '../../components/charts/charts/LineChart';
import BarChart from '../../components/charts/charts/BarChart';
import PieChart from '../../components/charts/charts/PieChart';
import AssessmentBarChart from '../../components/charts/charts/AssessmentBarChart';
import AssessmentCompletionChart from '../../components/charts/AssessmentCompletionChart';
import CategoryRadarChart from '../../components/charts/CategoryRadarChart';
import './Dashboard.css';
import { getComplianceDashboard, getComplianceForEachStandardDashboard, getUsersTasksDashboard, getAssessmentDashboard, getDetailedAssessment } from '../../services/dashboards'; // Import the API call
import AssessmentDetailsChart from '../../components/charts/AssessmentDetailsChart';
import { useTranslation } from 'react-i18next';
import LoadingScreen from 'src/Loading/LoadingScreen';
import { RiProgress2Line } from 'react-icons/ri';
import ResultAssessment from './resultAssessment';
import { getObjectivesFromBackend, getControlMapperFromBackend } from '../../services/objectiveAIServices';
import ObjectivesPriorityChart from '../../components/charts/ObjectivesPriorityChart';
import ObjectivesEffortChart from '../../components/charts/ObjectivesEffortChart';
import ObjectivesTimelineChart from '../../components/charts/ObjectivesTimelineChart';
import ObjectivesByRegulationChart from '../../components/charts/ObjectivesByRegulationChart';
interface Post {
  id: number;
  title: string;
  updatedAt: string;
}

interface DashboardProps {
  posts: Post[];
  isFetching: boolean;
}





function Dashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [complianceStatus, setComplianceStatus] = useState<any>([]);
  const [monthlyTasks, setMonthlyTasks] = useState<any>([]);
  const [complianceForEachStandard, setComplianceForEachStandard] = useState<any>([]);
  const [usersTasksDashboard, setUsersTasksDashboard] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [assessmentDashboard, setAssessmentDashboard] = useState<any | null>(null);
  const [detailedAssessment, setDetailedAssessment] = useState<any | null>(null);
  const [isAssessmentLoading, setIsAssessmentLoading] = useState(true);
  const [objectivesData, setObjectivesData] = useState<any[] | null>(null);
  const [isObjectivesLoading, setIsObjectivesLoading] = useState(true);
  const [controlMapperData, setControlMapperData] = useState<any | null>(null);
  const [isControlMapperLoading, setIsControlMapperLoading] = useState(true);


  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      const data = await getComplianceDashboard();
      
      if (data.success) {
        setDashboardData(data.data);
        setComplianceStatus([{
          'Compliance': data?.data?.compliance,
          'Non_Compliance': data?.data?.non_compliance,
          'Partially': data?.data?.partially,
          'Not_Started': data?.data?.not_started,
          'In_Progress': data?.data?.in_progress,
          'Done': data?.data?.done,
          // 'Overdue': data?.data?.overdue
        }])
      
        const monthlyTasksWithMonthNames = data.data.monthlyTasks.map((task: any, index: number) => {
          const monthNames = [t("Jan"), t("Feb"), t("Mar"), t("Apr"), t("May"), t("Jun"), t("Jul"), t("Aug"), t("Sep"), t("Oct"), t("Nov"), t("Dec")];
          return { name: monthNames[index], noTasks: task };
        });
       
        setMonthlyTasks(monthlyTasksWithMonthNames);
        
      } else {
        setDashboardData(null);
      }
      
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchComplianceForEachStandardDashboard = async () => {
    try {
      const data = await getComplianceForEachStandardDashboard();
      if (data.success) {
        const formattedData = data.data ? Object.keys(data.data).map((key: string) => ({
          id: key,
          reference_name: data.data[key].reference_name,
          fully_implemented: data.data[key].fully_implemented,
          mostly_implemented: data.data[key].mostly_implemented,
          averagely_implemented: data.data[key].averagely_implemented,
          implemented: data.data[key].implemented,
          partially_compliant: data.data[key].partially_compliant,
          non_compliant: data.data[key].non_compliant
        })) : [];
        
        setComplianceForEachStandard(formattedData);
      }
      
    } catch (error) {
      console.error("Error fetching compliance for each standard dashboard:", error);
    }
  }

  const fetchUsersTasksDashboard = async () => {
    try {
      const data = await getUsersTasksDashboard();
      if (data.success) {
        setUsersTasksDashboard(data.data);
      }
     // console.log(data);
    } catch (error) {
      console.error("Error fetching users tasks dashboard:", error);
    }
  }

  const fetchAssessmentDashboard = async () => {
    setIsAssessmentLoading(true);
    try {
      const res = await getAssessmentDashboard();
      if (res.success) {
        setAssessmentDashboard(res.data);
      } else {
        setAssessmentDashboard(null);
      }
    } catch (error) {
      console.error('Error fetching assessment dashboard:', error);
      setAssessmentDashboard(null);
    } finally {
      setIsAssessmentLoading(false);
    }
  };

  const fetchDetailedAssessment = async () => {
    try {
      const res = await getDetailedAssessment();
      if (res.success) {
        setDetailedAssessment(res.data);
      } else {
        setDetailedAssessment(null);
      }
    } catch (error) {
      console.error('Error fetching detailed assessment:', error);
      setDetailedAssessment(null);
    }
  };

  const fetchObjectives = async () => {
    setIsObjectivesLoading(true);
    try {
      const objectives = await getObjectivesFromBackend();
      if (objectives && Array.isArray(objectives) && objectives.length > 0) {
        // Extract roadmap from the first item
        const roadmap = objectives[0]?.roadmap || [];
        setObjectivesData(roadmap);
      } else {
        setObjectivesData(null);
      }
    } catch (error) {
      console.error('Error fetching objectives:', error);
      setObjectivesData(null);
    } finally {
      setIsObjectivesLoading(false);
    }
  };

  const fetchControlMapper = async () => {
    setIsControlMapperLoading(true);
    try {
      const data = await getControlMapperFromBackend();
      if (
        data &&
        (
          (data.individual && Array.isArray(data.individual) && data.individual.length > 0) ||
          (data.grouped && Array.isArray(data.grouped) && data.grouped.length > 0)
        )
      ) {
        setControlMapperData(data);
      } else {
        setControlMapperData(null);
      }
    } catch {
      setControlMapperData(null);
    } finally {
      setIsControlMapperLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchComplianceForEachStandardDashboard();
    fetchUsersTasksDashboard();
    fetchAssessmentDashboard();
    fetchDetailedAssessment();
    fetchObjectives();
    fetchControlMapper();
  }, []);

  const controlMapperSummary = React.useMemo(() => {
    if (!controlMapperData) {
      return {
        totalIndividual: 0,
        totalGroupedSets: 0,
        totalGroupedControls: 0,
        totalControls: 0,
        ownerChartData: [] as { name: string; value: number }[],
      };
    }

    const totalIndividual = Array.isArray(controlMapperData.individual)
      ? controlMapperData.individual.length
      : 0;

    const totalGroupedSets = Array.isArray(controlMapperData.grouped)
      ? controlMapperData.grouped.length
      : 0;

    const totalGroupedControls = Array.isArray(controlMapperData.grouped)
      ? controlMapperData.grouped.reduce(
          (sum: number, group: any) =>
            sum + (Array.isArray(group.mapped_controls) ? group.mapped_controls.length : 0),
          0,
        )
      : 0;

    const totalControls = totalIndividual + totalGroupedControls;

    const ownerCounts: Record<string, number> = {};

    if (Array.isArray(controlMapperData.individual)) {
      controlMapperData.individual.forEach((item: any) => {
        const ownerName =
          item?.suggested_owner_role_department?.name || 'Unassigned';
        ownerCounts[ownerName] = (ownerCounts[ownerName] || 0) + 1;
      });
    }

    if (Array.isArray(controlMapperData.grouped)) {
      controlMapperData.grouped.forEach((group: any) => {
        const ownerName =
          group?.suggested_owner_role_department?.name || 'Unassigned';
        const groupCount = Array.isArray(group.mapped_controls)
          ? group.mapped_controls.length
          : 0;
        ownerCounts[ownerName] = (ownerCounts[ownerName] || 0) + groupCount;
      });
    }

    const ownerChartData = Object.entries(ownerCounts)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 5);

    return {
      totalIndividual,
      totalGroupedSets,
      totalGroupedControls,
      totalControls,
      ownerChartData,
    };
  }, [controlMapperData]);

  const controlMapperDistributionData = [
    { name: 'Individual Controls', value: controlMapperSummary.totalIndividual },
    { name: 'Grouped Controls', value: controlMapperSummary.totalGroupedControls },
  ].filter(item => item.value > 0);

  const CONTROL_MAPPER_COLORS = ['#3b82f6', '#10b981', '#f97316', '#6366f1', '#ef4444'];

  const controlDetailsData = React.useMemo(() => {
    if (!controlMapperData) return [];

    const details: {
      id: string;
      code: string;
      name: string;
      description: string;
      objective: string;
      owner: string;
      type: string;
      source: string;
      groupName?: string;
    }[] = [];

    if (Array.isArray(controlMapperData.individual)) {
      controlMapperData.individual.forEach((item: any) => {
        if (!item || !item.control) return;
        details.push({
          id: item.control.id,
          code: item.control.code || '',
          name: item.control.name || '',
          description: item.control.description || '',
          objective: item.control.objective || '',
          owner: item?.suggested_owner_role_department?.name || 'Unassigned',
          type: item.control.mandatoryType || 'N/A',
          source: 'Individual',
        });
      });
    }

    if (Array.isArray(controlMapperData.grouped)) {
      controlMapperData.grouped.forEach((group: any) => {
        if (!Array.isArray(group.mapped_controls)) return;
        group.mapped_controls.forEach((control: any) => {
          if (!control) return;
          details.push({
            id: control.id,
            code: control.code || '',
            name: control.name || '',
            description: control.description || '',
            objective: control.objective || '',
            owner: group?.suggested_owner_role_department?.name || 'Unassigned',
            type: control.mandatoryType || 'N/A',
            source: 'Grouped',
            groupName: group?.name || '',
          });
        });
      });
    }

    return details;
  }, [controlMapperData]);

  const formatDate = (str: string) => {
    return str.replace(/,.*$/, "");
  };

  const toggleDropdown = () => {
    setIsDropdownOpened(!isDropdownOpened);
  };

  if (isLoading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }


  return (
   <>
    <div className="root dashboard">
     
        <>
          
         
            <div className="d-flex align-items-center justify-content-between mb-3 px-3">
          <h4 className="mb-lg me-3">{t('Dashboard.Dashboard')}</h4>
         
        </div>
       <div>
      <Row className='mb-3' >
           
           <Col sm={12} md={3} className="rounded">
             <div className='card bg-white h-100 p-3 shadow-sm'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
                <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Remaining_Tasks')}</h6>
              <h2 className="mt-2">{dashboardData?.in_progress + dashboardData?.not_started}</h2>
 
              </div>
              <div className='bg-primary p-2 rounded'>
                  <FaExclamationCircle size={20} className="text-white" />
                </div>
                </div>
                </div>
            </Col>
 
          
           <Col sm={12} md={3} className="rounded">
             <div className='card bg-white h-100 p-3 shadow-sm'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
               
                <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Completed_Tasks')}</h6>
              <h2 className="mt-2">{dashboardData?.done}</h2>
 
              </div>
              <div className='bg-success p-2 rounded'>
              <FaCheckCircle size={20} className="text-white" />
              </div>
              </div>
              </div>
            </Col>
 
           
           <Col sm={12} md={3} className="rounded">
             <div className='card bg-white h-100 p-3 shadow-sm'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
                 
                <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Tasks_in_progress')}</h6>
              <h2 className="mt-2">{dashboardData?.in_progress}</h2>
 
              </div>
              <div className='bg-warning p-2 rounded'>
 
              <RiProgress2Line size={20} className="text-white" />
              </div>
              </div>
              </div>
            </Col>
            
 
            {/* <Col sm={12} md={3} className="rounded">
              <div className='card  h-100 p-3'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
                  <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Overdue_tasks')}</h6>
 
                  <h2 className="mt-2">{dashboardData?.overdue}</h2>
                  </div>
 
               
                <div className='bg-danger p-2 rounded'>
                    <FaExclamationTriangle size={20} className="text-white" />
                  </div>
                </div>
              
              </div>
            </Col> */}
          </Row>

          {/* Objectives Charts Section */}
          {!isObjectivesLoading && objectivesData && objectivesData.length > 0 && (
            <>
              <Row className="mt-3">
                <Col xs={12}>
                  <h4 className="mb-3 px-3">
                    <i className="fa fa-bullseye mr-xs opacity-70" /> Compliance Objectives Overview
                  </h4>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col sm={12} md={3} className="rounded">
                  <div className='card bg-white h-100 p-3 shadow-sm'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                      <div>
                        <h6 className="fw-semi-bold text-gray-600">Total Objectives</h6>
                        <h2 className="mt-2">{objectivesData.length}</h2>
                      </div>
                      <div className='bg-primary p-2 rounded'>
                        <FaTasks size={20} className="text-white" />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={3} className="rounded">
                  <div className='card bg-white h-100 p-3 shadow-sm'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                      <div>
                        <h6 className="fw-semi-bold text-gray-600">High Priority</h6>
                        <h2 className="mt-2">{objectivesData.filter((obj: any) => obj.priority_rank <= 2).length}</h2>
                      </div>
                      <div className='bg-danger p-2 rounded'>
                        <FaExclamationCircle size={20} className="text-white" />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={3} className="rounded">
                  <div className='card bg-white h-100 p-3 shadow-sm'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                      <div>
                        <h6 className="fw-semi-bold text-gray-600">High Effort</h6>
                        <h2 className="mt-2">{objectivesData.filter((obj: any) => obj.estimated_effort === 'High').length}</h2>
                      </div>
                      <div className='bg-warning p-2 rounded'>
                        <FaExclamationTriangle size={20} className="text-white" />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={3} className="rounded">
                  <div className='card bg-white h-100 p-3 shadow-sm'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                      <div>
                        <h6 className="fw-semi-bold text-gray-600">Regulatory Frameworks</h6>
                        <h2 className="mt-2">
                          {new Set(objectivesData.map((obj: any) => obj.regulatory_reference)).size}
                        </h2>
                      </div>
                      <div className='bg-info p-2 rounded'>
                        <FaCheckCircle size={20} className="text-white" />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={12} md={6}>
                  <Widget className="custom-widget">
                    <h5 className="widget-title">
                      <span className="fw-semi-bold">Objectives by Priority</span>
                    </h5>
                    <hr className="widget-separator" />
                    <ObjectivesPriorityChart data={objectivesData} />
                  </Widget>
                </Col>
                <Col xs={12} md={6}>
                  <Widget className="custom-widget">
                    <h5 className="widget-title">
                      <span className="fw-semi-bold">Objectives by Estimated Effort</span>
                    </h5>
                    <hr className="widget-separator" />
                    <ObjectivesEffortChart data={objectivesData} />
                  </Widget>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={12} md={6}>
                  <Widget className="custom-widget">
                    <h5 className="widget-title">
                      <span className="fw-semi-bold">Objectives Timeline</span>
                    </h5>
                    <hr className="widget-separator" />
                    <ObjectivesTimelineChart data={objectivesData} />
                  </Widget>
                </Col>
                <Col xs={12} md={6}>
                  <Widget className="custom-widget">
                    <h5 className="widget-title">
                      <span className="fw-semi-bold">Objectives by Regulatory Reference</span>
                    </h5>
                    <hr className="widget-separator" />
                    <ObjectivesByRegulationChart data={objectivesData} />
                  </Widget>
                </Col>
              </Row>
            </>
          )}

          {/* Call-to-action when no objectives exist */}
          {!isObjectivesLoading && (!objectivesData || objectivesData.length === 0) && (
            <Row className="mt-3">
              <Col xs={12}>
                <div className="card bg-white p-4 shadow-sm d-flex flex-column flex-md-row align-items-center justify-content-between">
                  <div className="mb-3 mb-md-0">
                    <h5 className="fw-semi-bold text-gray-800 mb-1">
                      No objectives found for your organization
                    </h5>
                    <p className="text-muted mb-0">
                      Generate your AI-powered compliance objectives to unlock roadmap and charts.
                    </p>
                  </div>
                  <Button
                    color="primary"
                    className="mt-2 mt-md-0"
                    onClick={() => navigate('/objective')}
                  >
                    Go to Objectives & Build Roadmap
                  </Button>
                </div>
              </Col>
            </Row>
          )}

        {/* Control Mapper Charts Section */}
        {controlMapperData && controlMapperSummary.totalControls > 0 && (
          <>
            <Row className="mt-4">
              <Col xs={12}>
                <h4 className="mb-3 px-3">
                  <i className="fa fa-shield mr-xs opacity-70" /> Control Mapper Overview
                </h4>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col xs={12} md={6}>
                <Widget className="custom-widget">
                  <h5 className="widget-title">
                    <span className="fw-semi-bold">Individual vs Grouped Controls</span>
                  </h5>
                  <hr className="widget-separator" />
                  {isControlMapperLoading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
                      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                      <div className="mt-3 text-muted">Loading control mapper data...</div>
                    </div>
                  ) : controlMapperDistributionData.length > 0 ? (
                    <ResponsiveContainer height={300} width="100%">
                      <RePieChart>
                        <Pie
                          data={controlMapperDistributionData}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={90}
                          innerRadius={40}
                          dataKey="value"
                        >
                          {controlMapperDistributionData.map((entry, index) => (
                            <Cell
                              key={entry.name}
                              fill={CONTROL_MAPPER_COLORS[index % CONTROL_MAPPER_COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <ReTooltip />
                        <ReLegend layout="horizontal" align="center" verticalAlign="bottom" />
                      </RePieChart>
                    </ResponsiveContainer>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
                      <span className="text-muted">No control mapper data available</span>
                    </div>
                  )}
                </Widget>
              </Col>
              <Col xs={12} md={6}>
                <Widget className="custom-widget">
                  <h5 className="widget-title">
                    <span className="fw-semi-bold">Top Owners by Number of Controls</span>
                  </h5>
                  <hr className="widget-separator" />
                  {isControlMapperLoading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
                      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                      <div className="mt-3 text-muted">Loading control mapper data...</div>
                    </div>
                  ) : controlMapperSummary.ownerChartData.length > 0 ? (
                    <ResponsiveContainer height={300} width="100%">
                      <ReBarChart
                        data={controlMapperSummary.ownerChartData}
                        margin={{ top: 20, right: 20, left: 0, bottom: 40 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" angle={-30} textAnchor="end" interval={0} height={60} />
                        <YAxis />
                        <ReTooltip />
                        <Bar dataKey="value" fill="#3b82f6" name="Controls" />
                      </ReBarChart>
                    </ResponsiveContainer>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
                      <span className="text-muted">No owner data available</span>
                    </div>
                  )}
                </Widget>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12}>
                <Widget className="custom-widget">
                  <h5 className="widget-title">
                    <span className="fw-semi-bold">Mapped Controls – Detailed View</span>
                  </h5>
                  <hr className="widget-separator" />
                  {isControlMapperLoading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
                      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                      <div className="mt-3 text-muted">Loading control mapper data...</div>
                    </div>
                  ) : controlDetailsData.length > 0 ? (
                    <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                      <table className="table table-striped table-hover mb-0">
                        <thead>
                          <tr>
                            <th style={{ minWidth: 90 }}>Code</th>
                            <th style={{ minWidth: 200 }}>Control Name</th>
                            <th style={{ minWidth: 260 }}>Description</th>
                            <th style={{ minWidth: 140 }}>Objective</th>
                            <th style={{ minWidth: 160 }}>Owner Department</th>
                            <th style={{ minWidth: 120 }}>Mandatory Type</th>
                            <th style={{ minWidth: 100 }}>Source</th>
                            <th style={{ minWidth: 200 }}>Group Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {controlDetailsData.map((control) => (
                            <tr key={control.id}>
                              <td>{control.code || '-'}</td>
                              <td>{control.name || '-'}</td>
                              <td>{control.description || '-'}</td>
                              <td>{control.objective || '-'}</td>
                              <td>{control.owner || '-'}</td>
                              <td>{control.type || '-'}</td>
                              <td>{control.source}</td>
                              <td>{control.groupName || (control.source === 'Grouped' ? '—' : 'N/A')}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 200 }}>
                      <span className="text-muted">No mapped controls found</span>
                    </div>
                  )}
                </Widget>
              </Col>
            </Row>
          </>
        )}

<Row className="mt-3">
  <Col xs={12} md={4}>
    <Widget className="custom-widget">
      <h5 className="widget-title">
        <span className="fw-semi-bold">Assessment Overall Score</span>
      </h5>
      <hr className="widget-separator" />
      {isAssessmentLoading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3 text-muted">Loading assessment data...</div>
        </div>
      ) : assessmentDashboard ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
          <div
            style={{
              width: 150,
              height: 150,
              borderRadius: '50%',
              border: '10px solid hsl(159, 100%, 51%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            }}
          >
            <div className="text-center">
              <div style={{ fontSize: 32, fontWeight: 700 }}>
                {assessmentDashboard.overallScore}%
              </div>
              <div style={{ fontSize: 13, color: '#64748b' }}>Overall Score</div>
            </div>
          </div>
          <div className="mt-3 text-center" style={{ fontSize: 14 }}>
            <div className="mb-2">
              <strong>Total Score:</strong> {assessmentDashboard.actualScore} / {assessmentDashboard.maxPossibleScore}
            </div>
            <div className="mb-2 text-muted">
              <strong>Questions Answered:</strong> {assessmentDashboard.answeredQuestions} / {assessmentDashboard.totalQuestions}
            </div>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {assessmentDashboard.totalQuestions > 0 
                ? `${Math.round((assessmentDashboard.answeredQuestions / assessmentDashboard.totalQuestions) * 100)}% completed`
                : 'No questions available'}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
          <span className="text-muted">No assessment data yet</span>
        </div>
      )}
    </Widget>
  </Col>

  <Col xs={12} md={8}>
    <Widget className="custom-widget">
      <h5 className="widget-title">
        <span className="fw-semi-bold">Assessment Score by Category</span>
      </h5>
      <hr className="widget-separator" />
      {isAssessmentLoading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3 text-muted">Loading category scores...</div>
        </div>
      ) : assessmentDashboard && assessmentDashboard.categories && assessmentDashboard.categories.length > 0 ? (
        <div>
          <AssessmentBarChart
            data={assessmentDashboard.categories.map((c: any) => ({
              categoryName: c.categoryName,
              score: c.score,
            }))}
          />
          <div className="mt-3 px-3" style={{ fontSize: 12 }}>
            <div className="row">
              {assessmentDashboard.categories.map((c: any, idx: number) => (
                <div key={idx} className="col-6 mb-2">
                  <strong>{c.categoryName}:</strong> {c.answeredQuestions} / {c.totalQuestions} answered ({c.score}%)
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
          <span className="text-muted">No category score data to display</span>
        </div>
      )}
    </Widget>
  </Col>
</Row>

<Row className="mt-3">
  <Col xs={12} md={4}>
    <Widget className="custom-widget">
      <h5 className="widget-title">
        <span className="fw-semi-bold">Completion Status</span>
      </h5>
      <hr className="widget-separator" />
      {isAssessmentLoading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 300 }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3 text-muted">Loading completion status...</div>
        </div>
      ) : assessmentDashboard ? (
        <AssessmentCompletionChart data={assessmentDashboard} />
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
          <span className="text-muted">No completion data available</span>
        </div>
      )}
    </Widget>
  </Col>

  <Col xs={12} md={8}>
    <Widget className="custom-widget">
      <h5 className="widget-title">
        <span className="fw-semi-bold">Category Performance Comparison</span>
      </h5>
      <hr className="widget-separator" />
      {isAssessmentLoading ? (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 400 }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <div className="mt-3 text-muted">Loading category comparison...</div>
        </div>
      ) : assessmentDashboard && assessmentDashboard.categories && assessmentDashboard.categories.length > 0 ? (
        <CategoryRadarChart data={assessmentDashboard} />
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 400 }}>
          <span className="text-muted">No category data available</span>
        </div>
      )}
    </Widget>
  </Col>
</Row>

<Row className="mt-3">
  <Col xs={12}>
    <Widget className="custom-widget">
      <h5 className="widget-title">
        <span className="fw-semi-bold">Detailed Assessment: Questions & Answers by Category</span>
      </h5>
      <hr className="widget-separator" />
      {detailedAssessment && detailedAssessment.categories && detailedAssessment.categories.length > 0 ? (
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <AssessmentDetailsChart data={detailedAssessment} />
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 200 }}>
          <span className="text-muted">No detailed assessment data available</span>
        </div>
      )}
    </Widget>
  </Col>
</Row>
<div className="assessment-card">
{/*<div className="card-header">

 <div className="card-actions">
  {/*} <button 
     onClick={() => navigate('/team-onboarding')}
     className="btn-primary"
   >
     Invite User
   </button>
   <button 
     onClick={() => navigate('/objective')}
     className="btn-outline"
   >
     View Objectives
   </button>
 </div>
</div>*/}

<div className="card-content">
 <ResultAssessment />
</div>
</div>



<Row className="mt-3">
           <Col xs={12}>
             <div className='bg-white p-3 rounded shadow-sm w-100'>
               <h5 className="mt-0 mb-3">
                 <i className="fa fa-user mr-xs opacity-70" /> {t('Dashboard.Users_Tasks')}
               </h5>
               <div className="table-responsive w-100">
                 <table className="styled-table rounded w-100">
                   <thead style={{backgroundColor:"#cccbca"}}>
                     <tr>
                       <th>{t('Dashboard.Name')}</th>
                       <th>{t('Dashboard.Username')}</th>
                       <th>{t('Dashboard.Email')}</th>
                       <th>{t('Dashboard.Not_Completed')}</th>
                     </tr>
                   </thead>
                   <tbody>
                     {usersTasksDashboard.map((user: any) => (
                       <tr key={user.id}>
                         <td>{user.name}</td>
                         <td>{user.username}</td>
                         <td>{user.email}</td>
                         <td>
                         <Badge color={user.inProgressTasks > 5 ? "danger" : user.inProgressTasks > 3 ? "warning" : "success"} className="ml-xs">
                           {user.inProgressTasks}
                         </Badge>
                       </td>
                     </tr>
                     ))}
                    
                    
                    
                    
                   </tbody>
                 </table>
               </div>
             </div>
           </Col>
         </Row>
       </div>

  
        

     </>
   
 </div>
 </>
  );
}

export default withTranslation()(Dashboard);
